import * as React from 'react';

import { Images } from '@own-local/ad-utils/lib/types';

const ORIGAMI_SMALL_SIZE = 300;
const ORIGAMI_MEDIUM_SIZE = 640;
const UNSPLASH_IMAGES_URL = "images.unsplash.com";
const AUTO_PARAM = "auto";
const WIDTH_PARAM = "w";
const HEIGHT_PARAM = "h";
const FIT_PARAM = "fit";
const CROP_PARAM = "crop";
const AUTO_VALUE = "format";
const FIT_VALUE = "crop";
const CROP_VALUE = "entropy";

export interface BackgroundProps {
  images: Images;
  adShape: 'horizontal' | 'vertical' | 'square';
}

export interface BackgroundState {
  loaded: boolean;
  width: number;
  height: number;
  imageShape: 'tall' | 'fat';
}

export default class Background extends React.Component<BackgroundProps, BackgroundState> {
  private image: HTMLImageElement;
  constructor(props: BackgroundProps) {
    super(props);

    this.image = new Image();
    let imageSrc = this.selectImageSize(props.images.picture);

    if (this.isUnsplashImage(imageSrc)) {
      imageSrc = this.addParamsToUnsplashUrl(imageSrc);
    }

    this.image.src = imageSrc;
    this.image.onload = this.handleImageLoaded;
    this.image.onerror = this.handleImageError;

    this.state = {
      loaded: false,
      imageShape: undefined,
      height: undefined,
      width: undefined,
    };
  }

  public handleImageLoaded = (e: Event) => {
    const w = e.target['width'];
    const h = e.target['height'];
    const imageShape = w > h ? 'fat' : 'tall';

    this.setState({
      loaded: true,
      height: h,
      width: w,
      imageShape,
    });
  };

  public handleImageError = () => {
    this.setState({ loaded: false });
  };

  public selectImageSize = (picture) => {
    const { lg, md, sm } = picture;
    const origamiWidth = window.innerWidth;
    const origamiHeight = window.innerHeight;

    if (origamiWidth <= ORIGAMI_SMALL_SIZE && origamiHeight <= ORIGAMI_SMALL_SIZE) {
      return sm;
    } else if (origamiWidth <= ORIGAMI_MEDIUM_SIZE && origamiHeight <= ORIGAMI_MEDIUM_SIZE) {
      return md;
    }

    return lg;
  };

  public isUnsplashImage = url => !!url && url.includes(UNSPLASH_IMAGES_URL);

  public addParamsToUnsplashUrl = (url) => {
    const width = window.innerWidth * 2;
    const height = window.innerHeight * 2;
    url = this.addParamToUrl(url, AUTO_PARAM, AUTO_VALUE);
    url = this.addParamToUrl(url, WIDTH_PARAM, width);
    url = this.addParamToUrl(url, HEIGHT_PARAM, height);
    url = this.addParamToUrl(url, FIT_PARAM, FIT_VALUE);
    url = this.addParamToUrl(url, CROP_PARAM, CROP_VALUE);
    return url;
  };

  public addParamToUrl = (url, key, value) => url += `&${key}=${value}`;

  public render() {
    const { adShape, images } = this.props;
    const { imageShape, loaded } = this.state;
    const { offsets } = images;
    const offset = offsets[adShape];

    if (loaded) {
      let backgroundImageUrl = this.image.src;
      let imageStyle = {} as any;

      if (!this.isUnsplashImage(backgroundImageUrl)) {
        const imgpos = {
          x: imageShape === 'fat' ? 50 + offset : 50,
          y: imageShape === 'tall' ? 50 + offset : 50,
        };
        if (adShape === 'horizontal') {
          imgpos.x = 50;
          imgpos.y = 50 + offset;
        } else if (adShape === 'vertical') {
          imgpos.x = 50 + offset;
          imgpos.y = 50;
        }
        imageStyle.backgroundPosition = `${imgpos.x}% ${imgpos.y}%`;
      }
      imageStyle.backgroundImage = `url(${backgroundImageUrl})`;

      return (
        <div
          className="background"
          style={imageStyle}
        />
      );
    } else {
      return (
        <div className="background" />
      );
    }
  }
}
